import { useContext, useEffect, useState } from 'react'
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { getRequest } from '../../../../../services/base'
import ConnectorToggle from './ConnectorToggle'
import PinRow from './PinRow'
import SearchConnectorsButton from './SearchConnectorsButton'
import { ConnectorPinsContext } from '../context/context'
import { NavContext } from '../../../../../context/global_context'

const ConnectorPinsSection = () => {
  let { vehicle, connector_id } = useParams()
  const [connectorData, setConnectorData] = useState({})
  const [connectorPins, setConnectorPins] = useState([])
  const [searchParams, setSearchParams] = useSearchParams()
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const [navState, navDispatch] = useContext(NavContext)

  const navigate = useNavigate()

  useEffect(() => {
    if (navState?.dtc_details?.length > 0) {
      getConnectorDetails()
    }
  }, [navState?.dtc_details])

  const getConnectorDetails = async () => {
    let res = await getRequest(
      `/api/connector/${connector_id}/?vehicle=${vehicle}`
    )
    if (res?.id) {
      setConnectorData(res)
      getConnectorPins()
    }
  }

  const goTomapping = () => {
    navigate({
      pathname: `/vehicles/${vehicle}/dtcs/mappings`,
      search: `?${createSearchParams({
        dtc_id: searchParams.getAll('dtc_id'),
        q: searchParams.get('q'),
      })}`,
    })
  }

  const getConnectorPins = async () => {
    let res = await getRequest(
      `/api/dtcs/connector_pins/?connector=${searchParams.get(
        'connector_name'
      )}&vehicle=${vehicle}`
    )
    if (res?.data?.length > 0) {
      setConnectorPins(res?.data)
      // if (navState?.destination_only) {
      //   res?.data.forEach((pin) => {
      //     let temp_pin = `${pin.pin_from}/${pin.circuit_name}**$$${pin.circuit_id}`
      //     dispatch({
      //       type: 'set_selected_pins_data',
      //       data: temp_pin,
      //     })
      //   })
      // }
    }
  }

  return (
    <div className="flex-1 w-1/3 flex flex-col p-4 bg-tracer-dark-blue flex-grow">
      <div className="flex">
        <div className="text-white p-2 w-4/5">
          <div className="font-bold">{connectorData?.name}</div>
          <div>{connectorData?.description}</div>
        </div>
        <div
          className="my-4 underline text-white text-center w-1/5 cursor-pointer"
          onClick={() => {
            goTomapping()
          }}
        >
          {' '}
          Clear
        </div>
      </div>
      {!navState?.destination_only ? (
        <>
          <div className="pt-2">
            <h1 className="text-sm text-center text-white">
              Is this a start or an end connector?
            </h1>
            <ConnectorToggle />
          </div>
          <div className="mt-4 w-full border border-blue-500 bg-tracer-lt-blue rounded-t text-white pl-4 text-sm">
            Pin Filter (Optional)
          </div>
          <div className="flex-auto overflow-auto h-0">
            {connectorPins.map((pin, index) => {
              return (
                <PinRow
                  name={`${pin.pin_from}/${pin.circuit_name}`}
                  value={`${pin.pin_from}/${pin.circuit_name}`}
                  description={pin.circuit_desc}
                  harnessName=""
                  circuitId={pin.circuit_id}
                  inputName={'pins'}
                  key={`pin-${index}`}
                  pin={pin.pin_from}
                  circuit_name={pin.circuit_name}
                />
              )
            })}
            {connectorPins?.length < 1 && connectorData?.name && (
              <span>Pins Not available</span>
            )}
          </div>

          {/* <div className="pt-2">
        <FilterConnectorsToggle />
      </div>

      <div className="pt-2">
        <SearchOldLevelsCheckbox />
      </div> */}
          {connectorPins?.length > 0 && <SearchConnectorsButton />}
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export default ConnectorPinsSection
